import React from "react";
import { ServiceTypeEnum } from "../../../../../../common-deprecated/types/SettingsType";
import useService from "../../../hooks/services/useService";
import { useBnbSelector } from "../../../redux/store";
import ServiceProduct from "./ServiceProduct";

const ServiceProductService = (): JSX.Element | null => {
    const serviceProducts = useBnbSelector((state) => state.items.serviceProducts);

    const data = useService(ServiceTypeEnum.Serviceplans);
    if (!data) return null;

    return (
        <>
            {serviceProducts.map((serviceProduct) => (
                <ServiceProduct serviceProduct={serviceProduct} />
            ))}
        </>
    );
};

export default ServiceProductService;
